import { useRef } from 'react';

const useInitialValue = <T>(value: T, key: number | string | undefined): T => {
  const ref = useRef<{ key: typeof key; value: T }>({ key, value });

  if (ref.current.key !== key) {
    ref.current = { key, value };
  }

  return ref.current.value;
};

export default useInitialValue;
